import type { LabTestDashboardTest } from '~/types'

function compareTests(
  a: LabTestDashboardTest,
  b: LabTestDashboardTest,
): number {
  const timeA = a.orderDate ? Date.parse(a.orderDate) : Number.NaN
  const timeB = b.orderDate ? Date.parse(b.orderDate) : Number.NaN
  if (Number.isNaN(timeA) && Number.isNaN(timeB)) {
    // fall through to id
  } else if (Number.isNaN(timeA)) {
    return 1
  } else if (Number.isNaN(timeB)) {
    return -1
  } else if (timeA !== timeB) {
    return timeA - timeB
  }

  const idA = a.id || a.testId || ''
  const idB = b.id || b.testId || ''
  return idA.localeCompare(idB)
}

/**
 * Stable ordering for dashboard lab test rows so list vs. detail API responses
 * (which may differ in array order) do not rearrange tests after load.
 */
export function sortLabDashboardTests(
  tests: LabTestDashboardTest[],
): LabTestDashboardTest[] {
  if (tests.length < 2) {
    return tests
  }

  return [...tests]
    .map((test, index) => ({ test, index }))
    .sort((a, b) => {
      const compared = compareTests(a.test, b.test)
      return compared !== 0 ? compared : a.index - b.index
    })
    .map(({ test }) => test)
}
